import type { MobileEvent } from '@evidia/shared-mobile';

type WindowType = typeof window & {
	fireMobileEvent?: (e: MobileEvent) => Promise<void>;
};

export const mobileEvent = (e: MobileEvent): Promise<void> =>
	(window as WindowType).fireMobileEvent?.(e) ?? Promise.resolve();
